<template>
  <div class="page">
    <div class="warning">营养康复内容仅供参考，涉及多种疾病患者营养应咨询医生或者营养师。</div>
    <div class="title">{{ data.diseaseName }}</div>
    <div class="content"
         v-html="data.glossary"></div>
    <div class="block"
         v-if="isShare == 1"></div>
    <div v-if="isShare == 1"
         class="download">
      <img class="logo"
           src="@/assets/logo.png">
      <div class="tip">不舒服，点点我！<br />哪里不舒服，就点哪里！</div>
      <a class="btn"
         href="/download">立即下载</a>
    </div>
  </div>
</template>

<script>
import { diseaseInfo } from '@/api/guidance'

export default {
  name: 'detail',
  data() {
    return {
      isShare: 0,
      id: null,
      data: {}
    }
  },
  created() {
    document.title = '名词解释'
    this.id = this.$route.query.id
    this.isShare = this.$route.query.isShare || 0
    this.init()
  },
  methods: {
    init() {
      diseaseInfo({ diseaseId: this.id }).then(res => {
        res.result.glossary = this.formatRichText(res.result.glossary)
        this.data = res.result
      })
    },
    formatRichText(detailText) {
      detailText = detailText.replace(/<img[^>]*>/gi, function (match) {
        return match.replace(/(style="(.*?)")|(width="(.*?)")|(height="(.*?)")/ig,
          'style="max-width:100%;height:auto;"')
      });
      return detailText;
    },
  }
}
</script>

<style scoped>
.warning {
  display: none;
  padding: 10px 15px;
  font-size: 12px;
  color: #e5ae54;
  background: #faeeda;
}
.title {
  padding: 10px 20px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #333;
}
.time {
  text-align: center;
  font-size: 14px;
  color: #999;
}
.content {
  padding: 0 20px;
  font-size: 18px;
}
.block {
  height: 75px;
}
.download {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 15px;
  background-color: white;
  border-top: 1px solid #f2f2f2;
}
.download .logo {
  width: 50px;
  height: 50px;
}
.download .tip {
  flex: 1;
  margin: 0 10px;
  font-size: 13px;
  color: #999999;
}
.download .btn {
  padding: 5px 15px;
  color: white;
  text-decoration: none;
  background: #0063aa;
  border-radius: 25px;
}
</style>